<template>
    <div>

        <vue-headful title="Delete Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`${backRoute}`">
                        {{ backLabel }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Delete Email Alert
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row mb-2">
                <div class="col-lg-5 col-12">
                    <div class="card">
                        <div class="card-header">Delete Email Alert</div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Waring:</strong> You are about to delete this Email Alert. This cannot be undone.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-danger" v-on:click="deleteAlert()" :disabled="deleting">
                <template v-if="deleting"><i class="fa fa-spinner fa-spin"></i> Deleting</template>
                <template v-else>Delete Email Alert</template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                deleting: false,
                errors: {},
                alert: {},
                fields: [],
                conditions: [],
                recipients: [],
                recipientTypes: [],
                titles: [],
                roles: [],
            }
        },

        computed: {

            backRoute(){
                //Make sure it's set
                if(!this.alert.asset_type)
                {
                    return '';
                }

                //Setup
                var route = '/'+this.alert.asset_type.toLowerCase() + 's';

                //Handle it
                switch(this.alert.asset_type)
                {
                    case 'Observation':

                        break;

                    case 'CustomFormEntry':
                        //Setup
                        route = '/custom-forms#alerts';
                        break;
                }

                //Send it
                return route;
            },

            backLabel(){
                //Setup
                var label = this.alert.asset_type + 's';

                //Handle it
                switch(this.alert.asset_type)
                {
                    case 'Observation':

                        break;

                    case 'CustomFormEntry':
                        //setup
                        label = 'Custom Forms';
                        break;
                }

                //Send it
                return label;
            },
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('/email-alerts/edit/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteAlert(){
                //Saving Flag
                this.deleting = true;
                this.errors = {};

                //Send it
                this.$http.post('/email-alerts/delete/'+this.alert.id)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Email Alert Deleted');

                        //Send to the View
                        this.$router.push(this.backRoute);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Delete Alert');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            }
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
